// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1nwTE","footer":"ModalFilter_footer__288fQ"};